<template>
  <div>
    <v-container
      v-if="$vuetify.breakpoint.smAndUp"
      fill-height
      style="max-width: 1200px; padding-top: 30px"
    >
      <v-row align="center" style="color: #fff">
        <v-col cols="12" lg="9" class="d-flex align-center" style="gap: 16px">
          <v-icon size="32" style="color: white; padding-bottom: 5px"
            >mdi-book-open-blank-variant-outline</v-icon
          >
          <h4
            class="font-weight-bold text-uppercase"
            :class="`text-h${titleSize}`"
          >
            {{ numero ? "Tópico" : "" }} {{ numero }} {{ (titulo && numero) ? "-" : "" }} {{ titulo ? titulo : "" }}
          </h4>
        </v-col>

        <!-- <v-col
          cols="12"
          lg="3"
          class="text-center d-flex flex-column align-end"
        >
          <div class="d-flex" style="gap: 8px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="white"
                  depressed
                  min-width="40"
                  style="padding: 0 8px"
                  @click="$router.push('/topico-1-podcast')"
                >
                  <v-icon color="primary">mdi-podcast</v-icon>
                </v-btn>
              </template>
              <span>Podcast</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="white"
                  depressed
                  min-width="40"
                  style="padding: 0 8px"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Atividade</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="white"
                  depressed
                  min-width="40"
                  style="padding: 0 8px"
                >
                  <v-icon color="primary">mdi-book-plus</v-icon>
                </v-btn>
              </template>
              <span>Material complementar</span>
            </v-tooltip>
          </div>
          <v-menu bottom offset-y="30" rounded="lg">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" v-bind="attrs" v-on="on" fab depressed small>
                <v-icon size="26" color="primary">mdi-plus-thick</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title class="primary--text d-flex align-center" style="gap: 12px;">
                  <v-icon color="primary">mdi-podcast</v-icon>
                  <span>Rádio Podcast</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-title class="primary--text d-flex align-center" style="gap: 12px;">
                  <v-icon color="primary">mdi-pencil</v-icon>
                  <span>Atividade Prática</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-title class="primary--text d-flex align-center" style="gap: 12px;">
                  <v-icon color="primary">mdi-book-plus</v-icon>
                  <span>Material Complementar</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col> -->
      </v-row>
    </v-container>

    <v-container v-else fill-height class="pt-5">
      <v-row style="color: #fff">
        <v-col cols="12" class="text-center">
          <h6 class="font-weight-light text-h6 text-center">
            Tópico {{ numero }}
          </h6>
          <h4 class="font-weight-bold text-h5 text-uppercase">{{ titulo }}</h4>
        </v-col>
      </v-row>
    </v-container>

    <v-divider
      v-if="$vuetify.breakpoint.smAndUp"
      style="background-color: white; margin: 20px 0; border: solid 1px white"
    ></v-divider>

    <v-divider
    v-else
      style="background-color: white; margin: 14px 0 0 0; border: solid 1px white"
    ></v-divider>
  </div>
</template>

<script>
export default {
  props: ["titulo", "numero", "titleSize"],
};
</script>

<style scoped></style>
